export const body = {
    border: "1px solid black",
    padding: "10px"
};

export const image = {
    height: "150px",
    width: "150px",
    border: "1px solid black"
};

export const columnRight = {
    textAlign: "right"
};

export const customTitle = {
    textDecoration: "underline"
};

export const progressArea = {
    display: "flex",
    flexDirection: "column",
    alignItems: "center"
};

export const progressBarBack = {
    backgroundColor: "white",
    width: "90%",
    height: "25px"
};

export const progressBarFront = {
    height: "100%",
    backgroundColor: "green"
};

export const modelAmounts = {
    paddingTop: "10px",
    paddingBottom: "10px"
};

export const printedControls = {
    display: "flex",
    alignItems: "center"
};

export const messageLogCounter = {
    textAlign: "right",
    color: "red"
};
